import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-image",
  "use": "icon-image-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-image\">\n  <path fill=\"currentColor\" d=\"M12.52,6.32l-1.6-1.6h-2.4l-1.6,1.6h-3.2v8h12v-8H12.52z M9.72,11.92c-1.104-0.008-1.992-0.896-1.984-2 c0.008-1.104,0.896-1.992,2-1.984c1.096,0.008,1.976,0.888,1.984,1.984c0.008,1.104-0.88,1.992-1.984,2 C9.728,11.92,9.728,11.92,9.72,11.92z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol